const s = require("./config.module.scss");
import { default as React, useEffect, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";

import { MonitoringConfigDto } from "core/backend/common";
import SelectField from "./selectField";

interface OwnProps {
    dto: MonitoringConfigDto;
    pages: string[];
    files: string[];
    setEditDto: (dto: MonitoringConfigDto) => void;
}

const EditableRow = ({ t, dto, pages, files, setEditDto }: OwnProps & WithTranslation) => {

    return (
        <>
            <td className="alignLeft">
                <SelectField values={pages.map(p => t(p))} selected={dto.page} onChange={s => setEditDto({ ...dto, page: s })} />
            </td>
            <td className="alignLeft">{dto.tableName}</td>
            <td>
                <SelectField values={files} selected={dto.fileType} onChange={s => setEditDto({ ...dto, fileType: s })} />
            </td>
            <td>
                <SelectField values={files} selected={dto.backupFileType} onChange={s => setEditDto({ ...dto, backupFileType: s })} />
            </td>
            <td className="alignLeft">
                <SelectField values={files} selected={dto.spanningFile} onChange={s => setEditDto({ ...dto, spanningFile: s })} />
            </td>
            <td className="alignLeft">
                <input type="text" style={{ width: "100%" }} value={dto.deadline} onChange={e => setEditDto({ ...dto, deadline: e.target.value })} />
            </td>
            <td>
                <input type="checkbox" checked={dto.active} onChange={e => setEditDto({ ...dto, active: e.currentTarget.checked })} />
            </td>
        </>
    );
}

export default withTranslation()(EditableRow);